export default __webpack_public_path__ + "static/conformance-results-e1f61ddf7b4686f458279fbe4f5ca284.webp";